import { PriorityRule } from "../agent-config-options";

/**
 * Render the markdown subsection appended to the
 * `issue-label-conventions` rule when `AgentConfigOptions.priorityRules`
 * is non-empty. Returns an empty string when the supplied array is
 * empty so callers can unconditionally concatenate the result.
 *
 * Precedence is **first match wins** — rules render in the order
 * supplied. The bundle's default inference heuristics act as the
 * fallback when no rule matches.
 */
export function renderPriorityRulesSection(
  rules: ReadonlyArray<PriorityRule>,
): string {
  if (rules.length === 0) {
    return "";
  }

  const lines: Array<string> = [
    "## Project-specific priority rules",
    "",
    "These rules are supplied by this project through",
    "`AgentConfigOptions.priorityRules` and override the generic inference",
    "heuristics above. Rules evaluate in the order listed; **first match",
    "wins**. The bundle's default heuristics apply only when no rule below",
    "matches.",
    "",
  ];

  rules.forEach((rule, index) => {
    const matchDetails: Array<string> = [];

    if (rule.match.labels && rule.match.labels.length > 0) {
      const labelList = rule.match.labels.map((l) => `\`${l}\``).join(", ");
      matchDetails.push(`labels: ${labelList}`);
    }
    if (rule.match.titleRegex) {
      matchDetails.push(`title regex: \`${rule.match.titleRegex}\``);
    }
    if (rule.match.bodyRegex) {
      matchDetails.push(`body regex: \`${rule.match.bodyRegex}\``);
    }
    if (rule.match.issueNumbers && rule.match.issueNumbers.length > 0) {
      const numberList = rule.match.issueNumbers.map((n) => `#${n}`).join(", ");
      matchDetails.push(`issue numbers: ${numberList}`);
    }

    const matchSummary =
      matchDetails.length > 0 ? matchDetails.join("; ") : "(no match fields)";

    lines.push(
      `${index + 1}. **\`priority:${rule.priority}\`** when ${matchSummary} — ${rule.rationale}`,
    );
  });

  return lines.join("\n");
}
